/**
 * Formatting and calculation helpers.
 * Ported from q2-goals.html lines 501-510.
 */

/**
 * Format a numeric value with its unit suffix.
 * @param {number|string} val
 * @param {string} unit - "$", "%", "", or any custom suffix
 */
export function fmt(val, unit) {
  if (val === null || val === undefined || val === '') return '—'
  if (!unit) return val
  if (unit === '$') return '$' + Number(val).toLocaleString()
  return val + ' ' + unit
}

/**
 * Calculate percent-of-target for a goal.
 * Handles three cases:
 *   - target = 0:       100% if current also 0, else 0%
 *   - lowerIsBetter:    metric where being under target is good (e.g. rank)
 *   - normal:           current / target, capped at 100
 *
 * @param {number} current
 * @param {number} target
 * @param {boolean} lowerIsBetter
 * @returns {number} integer percent 0–100
 */
export function calcPct(current, target, lowerIsBetter = false) {
  if (target === 0) return current === 0 ? 100 : 0
  if (lowerIsBetter) {
    return current <= target ? 100 : Math.max(0, Math.round((target / current) * 100))
  }
  return Math.min(100, Math.round((current / target) * 100))
}

/**
 * Pick a status color based on a percentage.
 * Mirrors the "green / amber / red" bands used throughout the old dashboard.
 */
export function statusColor(pct) {
  if (pct >= 80) return '#16a34a' // green
  if (pct >= 40) return '#d97706' // amber
  return '#dc2626' // red
}

/**
 * Title-case a string — "book $515k in new revenue" → "Book $515k in New Revenue"
 * Ported from q2-goals.html line 1419.
 */
export function toTitleCase(str) {
  if (!str) return ''
  return str.replace(/\w\S*/g, (t) => t.charAt(0).toUpperCase() + t.slice(1))
}
